<template>
    <detail-panel class="standard-detail-panel"
        :name="name"
        ref="p">
        <div class="standard-detail-panel-title"
            slot="header">
            <span>楼栋管理</span>
            <Button v-if="isActive && $can('add')"
                :disabled="loading"
                class="standard-detail-panel-header-btn"
                type="primary"
                size="small"
                @click.stop="addFloor">新增楼栋</Button>
        </div>
        <Table :loading="loading"
            :columns="columns"
            :data="tableData"
            class="standard-detail-inner-table"
            :height="500">
            <template v-slot:action="{ row }">
                <Button :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="toShowFloorInfo(row)">楼栋详情</Button>
                <Button v-if="row.houseResources == 1"
                    :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="toShowSourceInfo(row)">查看房源</Button>
                <Button v-if="$can('add') && row.houseResources != 1"
                    :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="addSource(row)">生成房源</Button>
                <PoptipButton v-if="$can('delete')"
                    :disabled="loading"
                    text="删除楼栋"
                    transfer
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => { rowConfirmDelete(row) }"></PoptipButton>
            </template>
        </Table>
        <smart-modal v-model="showFloorInfo"
            :title="houId ? '编辑楼栋信息' : '新增楼栋信息'"
            :height="380"
            :width="800"
            :maskClosable="false"
            :buttons.sync="floorFormBtns"
            @close-by-confirm="fetch">
            <floor-form v-if="showFloorInfo"
                :id="houId"></floor-form>
        </smart-modal>
        <smart-modal title="生成房源"
            :height="320"
            :width="600"
            v-model="showAddSource"
            @close-by-confirm="fetch"
            :maskClosable="false">
            <add-source v-if="showAddSource"
                :id="houId"></add-source>
        </smart-modal>
        <smart-modal v-model="showSourceInfo"
            title="查看房源"
            :height="650"
            :width="1200"
            :maskClosable="false"
            :buttons='[{ type: "default", text: "关闭", name: "cancel" }]'
            @close-by-confirm="fetch">
            <source-info v-if="showSourceInfo"
                :id="houId"
                :unitNum="unitNum"></source-info>
        </smart-modal>
    </detail-panel>
</template>
<script>
import { panelable, Panel as DetailPanel } from '_c/panel'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import Dict from '@/utils/dict'
import { floorList, floorDelete } from '@/api/proj-manager'
import FloorForm from './form'
import AddSource from './add-source'
import SourceInfo from './source-info'

export default {
    access: "projFloor",
    props: {
        name: String
    },
    mixins: [panelable],
    components: {
        DetailPanel,
        FloorForm,
        AddSource,
        SourceInfo
    },
    data() {
        return {
            houId: '',
            showFloorInfo: false,
            showAddSource: false,
            showSourceInfo: false,
            floorFormBtns: [],
            tableData: [],
            dict: {
                saleStatus: Dict.NULL
            },
            loading: false
        }
    },
    computed: {
        columns() {
            return [{
                    key: 'floorName',
                    title: '楼栋',
                    align: 'left',
                    minWidth: 150
                },
                {
                    key: 'buildArea',
                    title: '建筑面积',
                    align: 'right',
                    minWidth: 150,
                    render: pipeCell('currency')
                },
                {
                    key: 'levelNum',
                    title: '楼层总数',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'unitNum',
                    title: '单元数',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'unitHouseNum',
                    title: '每单元户数',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'totalCount',
                    title: '房源总数',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'surplusCount',
                    title: '剩余房源',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'sellCount',
                    title: '销控房源',
                    align: 'center',
                    minWidth: 150
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    slot: 'action',
                    minWidth: 240
                }
            ]
        }
    },
    methods: {
        fetch() {
            this.loading = true
            return floorList(this.projId).then(res => {
                let list = res.data.list || []
                list.forEach(el => {
                    let surplusCount =
                        parseInt(el.totalCount || 0) -
                        parseInt(el.sellCount || 0)
                    el.surplusCount = surplusCount >= 0 ? surplusCount : 0
                })
                this.tableData = list
                this.loading = false
                return Promise.resolve()
            }).finally(() => {
                this.$emit("on-change")
            })
        },
        addFloor() {
            this.houId = ''
            this.showFloorInfo = true
        },
        addSource(row) {
            this.houId = row.id
            this.showAddSource = true
        },
        toShowSourceInfo(row) {
            this.houId = row.id
            this.unitNum = row.unitNum
            this.showSourceInfo = true
        },
        toShowFloorInfo(row) {
            this.houId = row.id
            this.showFloorInfo = true
        },
        rowConfirmDelete(row) {
            this.loading = true
            floorDelete(row.id)
                .then(el => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    },
    created() {
        this.projId = this.$route.params.id
        this.loading = true
        Promise.all([Dict.get(['sale_status']), this.fetch()]).then(args => {
            let [dict] = args
            Object.keys(this.dict).forEach(key => {
                this.dict[key] = dict[key]
            })
        }).finally(() => this.loading = false)
    }
}
</script>